import api from './api';

export interface License {
    id: string;
    title: string;
    description: string;
    image_url: string;
    authority: string;
    issue_date: string;
    reference_no: string;
    created_at: string;
    updated_at: string;
}

export interface CreateLicenseData {
    title: string;
    description: string;
    image_url: string;
    authority: string;
    issue_date: string;
    reference_no: string;
}

export interface UpdateLicenseData {
    title: string;
    description: string;
    image_url: string;
    authority: string;
    issue_date: string;
    reference_no: string;
}

export interface ApiResponse<T> {
    success: boolean;
    data: T;
    error?: {
        code: string;
        message: string;
        message_fa: string;
    };
    meta?: {
        page: number;
        page_size: number;
        total_items: number;
        total_pages: number;
    };
}

export const licenseService = {
    getAll: async () => {
        const response = await api.get<ApiResponse<License[]>>('/licenses');
        return response.data.data;
    },

    getById: async (id: string) => {
        const response = await api.get<ApiResponse<License>>(`/licenses/${id}`);
        return response.data.data;
    },

    create: async (data: CreateLicenseData) => {
        const response = await api.post<ApiResponse<License>>('/licenses', data);
        return response.data.data;
    },

    update: async (id: string, data: UpdateLicenseData) => {
        const response = await api.put<ApiResponse<License>>(`/licenses/${id}`, data);
        return response.data.data;
    },

    delete: async (id: string) => {
        await api.delete<ApiResponse<void>>(`/licenses/${id}`);
    },

    uploadImage: async (file: File) => {
        const formData = new FormData();
        formData.append('image', file);
        const response = await api.post<ApiResponse<{ url: string }>>('/licenses/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    },
};
